import { canonicalUrlActions } from '../../../actions';
import createReducer from '../../../utils/createReducer';

export default createReducer('', {
  [canonicalUrlActions.set.type]: (state, { payload }) => payload,
});
